import { http, httpFile } from './http_service';

//Get all
export function all(){
    return http().get('/settings');
}
